import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TSButton from 'components/common/Button/Button';
import {
  useGetGlobalWelfareCheckSettingsQuery,
  useUpdateGlobalWelfareCheckSettingsMutation,
  useTriggerWelfareCheckPollMutation,
} from 'app/api/welfareCheckAdminApiSlice';

const WelfareCheckSettings = () => {
  const { data: settings, isLoading } = useGetGlobalWelfareCheckSettingsQuery();

  const [gracePeriodMinutes, setGracePeriodMinutes] = useState('');
  const [reminderIntervalMinutes, setReminderIntervalMinutes] = useState('');
  const [needHelpEnabled, setNeedHelpEnabled] = useState(false);

  useEffect(() => {
    if (settings) {
      setGracePeriodMinutes(settings.grace_period_minutes);
      setReminderIntervalMinutes(settings.reminder_interval_minutes);
      setNeedHelpEnabled(settings.need_help_enabled);
    }
  }, [settings]);

  const [updateGlobalSettings, { isLoading: isSaving }] =
    useUpdateGlobalWelfareCheckSettingsMutation();

  const [triggerPoll, { isLoading: isTriggering, data: pollResult }] =
    useTriggerWelfareCheckPollMutation();

  const handleSave = () => {
    updateGlobalSettings({
      grace_period_minutes: Number(gracePeriodMinutes),
      reminder_interval_minutes: Number(reminderIntervalMinutes),
      need_help_enabled: needHelpEnabled,
    });
  };

  if (isLoading) return <div>Loading...</div>;

  return (
    <div className="px-4 py-2">
      <Typography variant="h2" gutterBottom>
        Welfare Check Settings
      </Typography>

      <Typography variant="h4" className="py-2">
        Run now
      </Typography>
      <TSButton
        btnText="Run Welfare Check now"
        onClickFunc={() => triggerPoll()}
        isLoading={isTriggering}
      />
      {pollResult && (
        <Typography variant="body2" className="py-2">
          Processed {pollResult.processed} activities.
        </Typography>
      )}

      <Typography variant="h4" className="py-2" style={{ marginTop: '1.5rem' }}>
        Global defaults
      </Typography>
      <div className="flex flex-col gap-4" style={{ maxWidth: '320px' }}>
        <TextField
          type="number"
          label="Grace Period (minutes)"
          value={gracePeriodMinutes}
          onChange={(e) => setGracePeriodMinutes(e.target.value)}
        />
        <TextField
          type="number"
          label="Reminder Interval (minutes)"
          value={reminderIntervalMinutes}
          onChange={(e) => setReminderIntervalMinutes(e.target.value)}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={needHelpEnabled}
              onChange={(e) => setNeedHelpEnabled(e.target.checked)}
            />
          }
          label={'"I need help" enabled'}
        />
        <TSButton
          btnText="Save"
          onClickFunc={handleSave}
          isLoading={isSaving}
        />
      </div>
    </div>
  );
};

export default WelfareCheckSettings;
